import { useState } from 'react';
import { ALERT_ICON, CLOSE_ICON } from '../../assets/icons';
import { Button } from '@wot/components';
import BottomSheet from '../../components/Bottomsheet';

interface Props {
  issues: string[];
}

function ProfileIssues({ issues }: Props) {
  const [profileIssuesVisibility, setProfileIssuesVisibility] = useState(false);
  return (
    <>
      {issues.length !== 0 && (
        <div
          className="flex py-4 px-10 text-red-600 text-sm gap-2 items-center cursor-pointer"
          onClick={() => setProfileIssuesVisibility(true)}
        >
          <img src={ALERT_ICON} alt="request issues" className="h-4" />
          <p className="hover:underline font-medium">
            {`${issues.length} ${
              issues.length === 1 ? 'issue' : 'issues'
            } found. Click here to view and resolve them now.`}
          </p>
        </div>
      )}
      {profileIssuesVisibility && <IssuesModal setIssuesVisibility={setProfileIssuesVisibility} issues={issues} />}
    </>
  );
}

function IssuesModal({ setIssuesVisibility, issues }: any) {
  return (
    <BottomSheet>
      <>
        <div className="w-full flex justify-end py-10 px-10">
          <img src={CLOSE_ICON} alt="close" className="h-4 cursor-pointer" onClick={() => setIssuesVisibility(false)} />
        </div>
        <div className="w-full flex flex-col h-[550px] items-center px-20 pb-20 overflow-y-scroll">
          <h3 className="text-lg font-bold text-center pb-10">Issues</h3>
          <div className="w-[50%] w-max-[900px] flex flex-col justify-start leading-8">
            {issues.map((issue: string, i: number) => (
              <div key={i} className="flex gap-4 py-3 items-center text-primary text-center">
                <div className={`p-1 border border-black text-black text-center text-xs w-6 h-6 rounded-full`}>
                  {i + 1}
                </div>
                <p>{issue}</p>
              </div>
            ))}
          </div>
        </div>
        <hr />
        <div className="w-full max-w-sm mx-auto flex gap-6 justify-center items-center">
          <div className="py-3">
            <Button block type="s-outlined" text="Cancel" onClick={() => setIssuesVisibility(false)} />
          </div>
          <div className="py-3">
            <Button block text="Resolve Issues" onClick={() => setIssuesVisibility(false)} />
          </div>
        </div>
      </>
    </BottomSheet>
  );
}

export default ProfileIssues;
